import axios from "axios";
import Swal from "sweetalert2";
import { config } from "../config.js";
import { post, get } from './baseApi.service.js';

export const apiGetSetting = async () => {
  try {
    console.log("start")
    const result = await get("/api/setting", {site: "bo_789bet"});
    if (result?.status_code === 200) {
      return result;
    }
  } catch (error) {
    return Swal.fire({ icon: "error", text: "Lỗi kết nối, vui lòng thử lại sau." });
  }
};

export const apiCheckAccount = async (userName) => {
  let raw = JSON.stringify({
    account: userName,
  });
  try {
    const result = await post("/api/user/check",raw);
    if (result?.code === 200) {
      return result;
    }
  } catch (error) {
    return Swal.fire({ icon: "error", text: "Thao tác lỗi, vui lòng thử lại sau." });
  }
};

export const apiUpdateAccount = async (body) => {
  let raw = JSON.stringify(body);
  try {
    const result = await post("/api/user/info-update",raw);
    if (result?.code === 200) {
      return result.data;
    } else {
      if (!result) return false;
      Swal.fire({
        icon: "error",
        title: result.error,
        text: result.message,
      });
      return false;
    }
  } catch (error) {
    console.error("error", error);
    Swal.fire({ icon: "error", text: "Không thể gửi yêu cầu. Vui lòng thử lại." });
    return false;
  }
};

export const apiCheckDataAccount = async (body) => {
  let raw = JSON.stringify(body);
  try {
    const result = await post("/api/user/check-data-old",raw);
    if (result.code === 200) {
      return result.data;
    } else {
      if(result.code === 202) {
        Swal.fire({
          icon: "error",
          title: result.error,
          text: result.message,
        });
      }
      return false;
    }
  } catch (error) {
    console.error("error", error);
  }
};

export const apiConfirmUpdate = async (body) => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  let raw = JSON.stringify(body);
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`${config.BE_API_URL}/api/user/confirm-update`, requestOptions);
    const result = await response.json();
    if (result.code === 200) {
      return result.data;
    } 
  } catch (error) {
    console.error("error", error);
  }
};
export const apiGetRequestHistory = async (account, requestCode) => {
  try {
    const response = await axios.post(config.BE_API_URL + "/api/user/request-history", {
      account,
      request_code: requestCode,
    }, { timeout: 20000 });
    return response.data;
  } catch (error) {
    return { code: 500, message: "Không thể cập nhật trạng thái. Vui lòng thử lại." };
  }
};
